import React, {FunctionComponent} from "react";
import {Article, BlogTitleLink, CaseStudy} from "@klear/open-site";

const styles = require('./moreArticles.module.scss');

interface MoreArticlesProps {
    mainTitle: string,
    sideTitle?: string,
    sectionIcon?: string,
    posts: Array<{ node: CaseStudy }>;
    isCategoryPage: boolean
    isLink?: boolean
}

export const MoreArticles: FunctionComponent<MoreArticlesProps> = ({sectionIcon, mainTitle, posts, isCategoryPage, sideTitle, isLink}) => {
    return (
        <>
            <div className={styles.container}>
                {/*Inner pages do not need title to be a link*/}
                <BlogTitleLink mainTitle={mainTitle} sectionIcon={sectionIcon} sideTitle={sideTitle} divider={true}/>
                <div className={`${styles.containerBottom} ${isCategoryPage ? styles.categoryPage : styles.mainPage} `}>
                    {posts.map(({node}) => (
                        <div className={styles.mainArticle}>
                                <a href={`${node.slug}/`}>
                                    <Article mainArticleImage={node.mainImage.url}
                                                 mainArticleTitle={node.caseTitle}
                                                 mainArticleDescription={node.caseDescription || ''}
                                                 isSmall={true}
                                    />
                                </a>
                            <div className={styles.gotToArticleCont}>
                                <div className={styles.gotToArticleSmall}>
                                    <div className={styles.goToIcon}>
                                        <i className='fa fa-arrow-right'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};
